import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';

const ProtectedRoute = ({ auth, children }) => {
  const [user, loading, error] = useAuthState(auth);

  if (loading) {
    return <div>Loading...</div>; // Mostra un indicatore di caricamento mentre la verifica dell'utente è in corso
  }

  if (!user) {
    return <Navigate to="/login" />; // Reindirizza alla pagina di login se l'utente non è autenticato
  }

  return children; // Renderizza il contenuto protetto se l'utente è autenticato
};

export default ProtectedRoute;
